"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProjectParticipantsDataProvider = exports.useProjectParticipantsDataContext = void 0;
const React = __importStar(require("react"));
const react_1 = require("react");
const Commons_1 = require("src/configeek_assets/src/components/common/provider/Commons");
const typescriptAddons_1 = require("src/configeek_assets/src/system/typescriptAddons");
const ActorsProvider_1 = require("src/configeek_assets/src/components/common/provider/ActorsProvider");
const ICCanisterUtils_1 = require("src/configeek_assets/src/ic/ICCanisterUtils");
const lodash_1 = __importDefault(require("lodash"));
const DateTimeUtils_1 = require("src/configeek_assets/src/system/mics/DateTimeUtils");
const use_custom_compare_1 = require("use-custom-compare");
const initialContextValue = {
    participants: (0, Commons_1.getDefaultCGFeature)()
};
const ProjectParticipantsDataContext = React.createContext(undefined);
const useProjectParticipantsDataContext = () => {
    const context = React.useContext(ProjectParticipantsDataContext);
    if (!context) {
        throw new Error("useProjectParticipantsDataContext must be used within a ProjectParticipantsDataContext.Provider");
    }
    return context;
};
exports.useProjectParticipantsDataContext = useProjectParticipantsDataContext;
const ProjectParticipantsDataProvider = (props) => {
    const actorsContext = (0, ActorsProvider_1.useActorsContext)();
    const [participants, updateParticipants] = (0, react_1.useReducer)(Commons_1.simpleFeatureReducer, initialContextValue.participants);
    const fetchParticipants = (0, react_1.useCallback)(async () => {
        updateParticipants({ status: { inProgress: true } });
        try {
            const managementActor = await actorsContext.getManagementActor();
            if (managementActor) {
                const getProjectParticipantsResult = await managementActor.getProjectParticipants(props.projectApiKey);
                if ((0, ICCanisterUtils_1.isOk)(getProjectParticipantsResult)) {
                    const participantViews = getProjectParticipantsResult.ok;
                    // console.log(`ProjectParticipantsDataProvider.fetchParticipants: got participantViews`, participantViews);
                    updateParticipants({
                        status: { inProgress: false, loaded: true },
                        error: { error: undefined, isError: false },
                        data: {
                            participantViews: participantViews
                        },
                        time: { updatedAt: DateTimeUtils_1.DateTimeUtils.now() }
                    });
                    return;
                }
                else if ((0, ICCanisterUtils_1.isErr)(getProjectParticipantsResult)) {
                    const errorName = (0, ICCanisterUtils_1.getICRequestErrName)(getProjectParticipantsResult);
                    console.error(`ProjectParticipantsDataProvider.fetchParticipants: got error`, errorName);
                    updateParticipants({
                        status: { inProgress: false, loaded: true },
                        error: { error: new Error(errorName), isError: true },
                        data: undefined,
                    });
                    return;
                }
            }
            else {
                // noinspection ExceptionCaughtLocallyJS
                throw new Error("noActor");
            }
            // noinspection ExceptionCaughtLocallyJS
            throw new Error("unknown");
        }
        catch (e) {
            console.warn("ProjectParticipantsDataProvider.fetchParticipants: caught error", e);
            updateParticipants({
                status: { inProgress: false, loaded: true },
                error: { error: e, isError: true },
                data: undefined,
            });
        }
    }, [props.projectApiKey, actorsContext.getManagementActor]);
    const addNewViewerParticipant = (0, react_1.useCallback)(async (principal, name) => {
        try {
            const managementActor = await actorsContext.getManagementActor();
            if (managementActor) {
                const result = await managementActor.addNewViewerParticipant(props.projectApiKey, principal.toText(), name);
                if ((0, ICCanisterUtils_1.isOk)(result)) {
                    return { status: "success", result: undefined };
                }
                else if ((0, ICCanisterUtils_1.isErr)(result)) {
                    const error = result.err;
                    console.error(`ProjectParticipantsDataProvider.addNewViewerParticipant: got error`, error);
                    if ((0, typescriptAddons_1.hasOwnProperty)(error, "validationError")) {
                        const validationError = error.validationError;
                        const validationErrorName = (0, ICCanisterUtils_1.getICFirstKey)(validationError);
                        return { status: "error", reason: validationErrorName };
                    }
                    const errorName = (0, ICCanisterUtils_1.getICRequestErrName)(result);
                    return { status: "error", reason: errorName };
                }
            }
            else {
                return { status: "unknownError", error: new Error("noActor") };
            }
            return { status: "unknownError", error: new Error("unknown") };
        }
        catch (e) {
            return { status: "unknownError", error: e };
        }
    }, [props.projectApiKey, actorsContext.getManagementActor]);
    const removeParticipant = (0, react_1.useCallback)(async (principal) => {
        try {
            const managementActor = await actorsContext.getManagementActor();
            if (managementActor) {
                const removeParticipantResult = await managementActor.removeParticipant(props.projectApiKey, principal.toText());
                if ((0, ICCanisterUtils_1.isOk)(removeParticipantResult)) {
                    return { status: "success", result: undefined };
                }
                else if ((0, ICCanisterUtils_1.isErr)(removeParticipantResult)) {
                    console.error(`ProjectParticipantsDataProvider.removeParticipant: got error`, removeParticipantResult.err);
                    const errorName = (0, ICCanisterUtils_1.getICRequestErrName)(removeParticipantResult);
                    return { status: "error", reason: errorName };
                }
            }
            else {
                return { status: "unknownError", error: new Error("noActor") };
            }
            return { status: "unknownError", error: new Error("unknown") };
        }
        catch (e) {
            return { status: "unknownError", error: e };
        }
    }, [props.projectApiKey, actorsContext.getManagementActor]);
    const updateParticipant = (0, react_1.useCallback)(async (principal, name) => {
        try {
            const managementActor = await actorsContext.getManagementActor();
            if (managementActor) {
                const result = await managementActor.updateParticipantName(props.projectApiKey, principal.toText(), name);
                if ((0, ICCanisterUtils_1.isOk)(result)) {
                    return { status: "success", result: undefined };
                }
                else if ((0, ICCanisterUtils_1.isErr)(result)) {
                    const error = result.err;
                    console.error(`ProjectParticipantsDataProvider.updateParticipant: got error`, error);
                    if ((0, typescriptAddons_1.hasOwnProperty)(error, "validationError")) {
                        const validationError = error.validationError;
                        const validationErrorName = (0, ICCanisterUtils_1.getICFirstKey)(validationError);
                        return { status: "error", reason: validationErrorName };
                    }
                    const errorName = (0, ICCanisterUtils_1.getICRequestErrName)(result);
                    return { status: "error", reason: errorName };
                }
            }
            else {
                return { status: "unknownError", error: new Error("noActor") };
            }
            return { status: "unknownError", error: new Error("unknown") };
        }
        catch (e) {
            return { status: "unknownError", error: e };
        }
    }, [props.projectApiKey, actorsContext.getManagementActor]);
    const value = (0, use_custom_compare_1.useCustomCompareMemo)(() => ({
        participants,
        fetchParticipants,
        removeParticipant,
        addNewViewerParticipant,
        updateParticipant,
    }), [
        participants,
        fetchParticipants,
        removeParticipant,
        addNewViewerParticipant,
        updateParticipant,
    ], lodash_1.default.isEqual);
    return React.createElement(ProjectParticipantsDataContext.Provider, { value: value }, props.children);
};
exports.ProjectParticipantsDataProvider = ProjectParticipantsDataProvider;
